import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";

import {
  addProductStyleAsync,
  addProductInseamLabelAsync,
  deleteProductInseamLabelAsync,
  editProductStyleAsync,
  editProductInseamLabelAsync,
  getProductStyleAsync,
  getProductInseamLabelAsync,
} from "../../../../store/services/productInfoServices";
const InseamLabel = () => {
  const dispatch = useDispatch();
  const {
    getProductInseamLabelStatus,
    getProductInseamLabelError,
    getProductInseamLabelData,
    addProductInseamLabelStatus,
    addProductInseamLabelData,
    addProductInseamLabelError,

    editProductInseamLabelStatus,
    editProductInseamLabelError,
    editProductInseamLabelData,

    deleteProductInseamLabelData,
    deleteProductInseamLabelStatus,
    deleteProductInseamLabelError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductInseamLabelAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductInseamLabelData?.length
    ? getProductInseamLabelData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedInseamLabel, setSelectedInseamLabel] = useState();
  const [addInseamLabelMode, setAddInseamLabelMode] = useState(false);
  const [addInseamLabelData, setAddInseamLabelData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedInseamLabel", selectedInseamLabel);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductInseamLabelStatus === asyncStatus.SUCCEEDED) {
      setAddInseamLabelMode(false);
      setSaveDisabled(true);
      setAddInseamLabelData();
    }
  }, [, addProductInseamLabelStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductInseamLabelAsync(selectedInseamLabel?.inseam_label_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductInseamLabelStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedInseamLabel();
    }
  }, [, deleteProductInseamLabelStatus]);
  useEffect(() => {
    if (editProductInseamLabelStatus === asyncStatus.SUCCEEDED) {
      setSelectedInseamLabel();
      setEditMode(false);
    }
  }, [, editProductInseamLabelStatus]);
console.log("getProductInseamLabelData",getProductInseamLabelData,editProductInseamLabelData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this Inseam Label?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Inseam Label"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Inseam Label Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddInseamLabelMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addInseamLabelMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addInseamLabelMode || !selectedInseamLabel}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddInseamLabelMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addInseamLabelMode || !selectedInseamLabel}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductInseamLabelStatus === asyncStatus.LOADING ||
                  editProductInseamLabelStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addInseamLabelData) {
                    dispatch(addProductInseamLabelAsync(addInseamLabelData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedInseamLabel, ...editData };
                    delete a.id;
                    dispatch(editProductInseamLabelAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "inseam_label_id", headerName: "ID", flex: true },
                  {
                    field: "inseam_label_name",
                    headerName: "Inseam Label Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedInseamLabel(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductInseamLabelStatus === asyncStatus.IDLE ||
                  getProductInseamLabelStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addInseamLabelMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Inseam Label:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddInseamLabelData({
                            ...addInseamLabelData,
                            inseam_label_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddInseamLabelData({
                            ...addInseamLabelData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedInseamLabel ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedInseamLabel?.inseam_label_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "InseamLabel:",
                    comp: (
                      <InputComp
                        key={selectedInseamLabel?.inseam_label_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            inseam_label_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedInseamLabel?.inseam_label_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedInseamLabel?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedInseamLabel?.is_active ? true : false
                        }
                        checked={selectedInseamLabel?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any inseam label</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductInseamLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductInseamLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductInseamLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductInseamLabelError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedInseamLabel(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedInseamLabel(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default InseamLabel;
